export default __webpack_public_path__ + "static/media/notSavedBookmark.3609adf0.svg";